import type { FieldValues } from 'react-hook-form';

export const getFilteredValues = <TFieldValues extends FieldValues>(
  values: TFieldValues,
  excludedKeys: Array<string>,
): Partial<TFieldValues> =>
  Object.entries(values)
    .filter(([key]) => !excludedKeys.includes(key))
    .reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {});
